import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoDependencia, cadastrarTipoDependencia, alterarTipoDependencia, excluirTipoDependencia } from './tipos_dependencias_service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var TiposDependenciasAlterar = function () {
    var services = {
        getItem: getTipoDependencia,
        cadastrarItem: cadastrarTipoDependencia,
        alterarItem: alterarTipoDependencia,
        excluirItem: excluirTipoDependencia,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_DEPENDENCIAS, paginaPermissao: FUNCIONALIDADES.TIPOS_DEPENDENCIAS, rota: ROUTES.TIPOS_DEPENDENCIAS, services: services });
};
export default TiposDependenciasAlterar;
